import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import styled from "@emotion/styled";
import { TextField } from "@mui/material";
import { V1ListCurrenciesTypeEnum } from "@rentablo/api/apiv1";
import { CurrencySelect } from "@components";
import { DEFAULT_CURRENCY } from "@constants";
import { StepContainer } from "../StepContainer";

const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing(6)};
  width: 100%;
`;

export interface Props {
  handleNext: (name: string, currency: string) => void;
  handlePrevious: () => void;
}

export const NewDepotStep = ({ handleNext, handlePrevious }: Props) => {
  const [name, setName] = useState<string>("");
  const [currency, setCurrency] = useState<string>(DEFAULT_CURRENCY);
  const { t } = useTranslation();

  const onNextDisabled = !name?.trim() || !currency;

  return (
    <StepContainer
      testid="new-depot-step"
      title={t("transactionWizard.newDepotStep.title")}
      onNext={() => {
        if (onNextDisabled) return;
        handleNext(name!, currency);
      }}
      onNextDisabled={onNextDisabled}
      onPrevious={handlePrevious}
    >
      <Container>
        <TextField
          autoComplete="off"
          label={t("transactionWizard.newDepotStep.name")}
          data-testid="name"
          fullWidth
          onChange={(event) => {
            setName(event.target.value);
          }}
          type="text"
          value={name}
          slotProps={{
            htmlInput: {
              style: { textAlign: "left" },
              "data-testid": "name-input",
            },
          }}
        />
        <CurrencySelect
          label={t("transactionWizard.newDepotStep.currency")}
          value={currency}
          onChange={setCurrency}
          testId="new-depot-currency"
          type={[V1ListCurrenciesTypeEnum.STANDARD]}
        />
      </Container>
    </StepContainer>
  );
};
